// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"584":"23cf2c666ea5d77608c1","994":"19afaabfffd436bf23b1"}[chunkId] + ".js";
};